import { createContext, useContext, type ReactNode } from 'react';

import type { StoryState } from '../hooks/useStory.js';

const CmsStoryContext = createContext<StoryState | undefined>(undefined);

export const CmsStoryProvider = ({
  children,
  story,
}: {
  children: ReactNode;
  story: StoryState;
}) => <CmsStoryContext.Provider value={story}>{children}</CmsStoryContext.Provider>;

export const useCmsStory = (): StoryState => {
  const story = useContext(CmsStoryContext);
  if (!story) {
    throw new Error('useCmsStory must be used within a CmsStoryProvider');
  }
  return story;
};
